import { FILE_STATUS } from 'pages/ExperienceCanvas/types';

export const PROCESSING_QUEUED = 'PROCESSING_QUEUED';

export type StatusGroup = 'processing' | 'paused' | 'ready' | 'failed';

export const STATUS_LABELS: Record<string, string> = {
  [FILE_STATUS.PROCESSING_SUCCESS]: 'Processed',
  [FILE_STATUS.PROCESSING]: 'Processing',
  [PROCESSING_QUEUED]: 'In Queue',
  [FILE_STATUS.PROCESSING_PAUSED]: 'Paused',
  [FILE_STATUS.UPLOADED]: 'Ready To Process',
  [FILE_STATUS.UPLOADING]: 'Uploading',
  [FILE_STATUS.PROCESSING_FAILED]: 'Failed To Process',
  [FILE_STATUS.UPLOADING_FAILED]: 'Failed To Upload',
};

export const STATUS_PRIORITY: Record<string, number> = {
  [FILE_STATUS.PROCESSING]: 1,
  [PROCESSING_QUEUED]: 1,
  [FILE_STATUS.PROCESSING_PAUSED]: 2,
  [FILE_STATUS.PROCESSING_FAILED]: 3,
  [FILE_STATUS.UPLOADING_FAILED]: 3,
  [FILE_STATUS.UPLOADED]: 4,
  [FILE_STATUS.UPLOADING]: 5,
  [FILE_STATUS.PROCESSING_SUCCESS]: 6,
};

export const PILL_DEFINITIONS: { key: string; label: string; status?: string }[] = [
  { key: 'all', label: 'All' },
  { key: 'processing', label: 'Processing', status: FILE_STATUS.PROCESSING },
  { key: 'paused', label: 'Paused', status: FILE_STATUS.PROCESSING_PAUSED },
  { key: 'failed', label: 'Failed', status: FILE_STATUS.PROCESSING_FAILED },
  { key: 'ready', label: 'Ready', status: FILE_STATUS.UPLOADED },
  { key: 'processed', label: 'Processed', status: FILE_STATUS.PROCESSING_SUCCESS },
  { key: 'uploading', label: 'Uploading', status: FILE_STATUS.UPLOADING },
];

export function classifyStatus(status: string): StatusGroup | null {
  if (status === FILE_STATUS.PROCESSING || status === PROCESSING_QUEUED) return 'processing';
  if (status === FILE_STATUS.PROCESSING_PAUSED) return 'paused';
  if (status === FILE_STATUS.UPLOADED) return 'ready';
  if (status === FILE_STATUS.PROCESSING_FAILED || status === FILE_STATUS.UPLOADING_FAILED) return 'failed';
  return null;
}

export function isFailedStatus(status: string) {
  return status === FILE_STATUS.PROCESSING_FAILED || status === FILE_STATUS.UPLOADING_FAILED;
}
